import { Component, OnInit } from '@angular/core';

import { Medida } from "../shared/medida.model";
import { medidasModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import { MedidaApiService } from "../shared/medida-api.service";
import { MedidaNavigationService } from "../shared/medida-navigation.service";
import { MedidaService } from "../shared/medida.service";

declare var swal: any;

@Component({
  template: require('./medida-list.component.html'),
})

export class MedidaListComponent implements OnInit {
  medidasModuleName: string = medidasModuleName;
  list: Array<Medida> = [];
  showDisabled: boolean = false;
  loading: boolean = true;

  constructor(
    private _medidaApiService: MedidaApiService,
    private _medidaService: MedidaService,
    private _medidaNavigationService: MedidaNavigationService,
    private _utilService: UtilService
  ){}

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._medidaService.clearSessionStorage();
    this._medidaNavigationService.goToNew();
  }

  clickEdit(item: Medida) {
    this._medidaService.clearSessionStorage();
    this._medidaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Medida) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._medidaApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._medidaApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/medida-list/medida-list.component.ts
 **/